import React, { useState, useRef, useEffect } from "react";
import { ImgIcon } from "../../assets";
import { downArrow } from "../../assets/icons";
import { trackEvent, EC_SHOP, E_CATEGORY_OPENED, E_CATEGORY_CLOSED } from "../../helpers/tracking";
import useCurrentCategory from "../../assets/hooks/useCurrentCategory";

export default function Category({ category, items, headerColor, children, expandedByDefault }) {

	const [currentCategory, setCurrentCategory] = useCurrentCategory();

	const [open, setOpen] = useState(expandedByDefault || currentCategory === category);
	const [finishedOpening, setFinishedOpening] = useState(open);
	const [itemsHeight, setItemsHeight] = useState(0);
	const itemsContainer = useRef(null);

	useEffect(() => {
		let to;
		if (open) {
			to = setTimeout(() => {
				setFinishedOpening(true);
			}, 500);
		} else {
			setFinishedOpening(false);
		}
		return () => {
			if (to) clearTimeout(to);
		}
	}, [open]);

	useEffect(() => {
		if (category === currentCategory) setOpen(true);
	}, [currentCategory, category]);

	useEffect(() => {
		function checkHeight() {
			let height = 0;
			itemsContainer.current
				.querySelectorAll(".items > *")
				.forEach(element => {
					height += element.offsetHeight;
				});
			if (height !== itemsHeight) setItemsHeight(height);
		}
		checkHeight();
		window.addEventListener("resize", checkHeight);
		return () => {
			window.removeEventListener("resize", checkHeight);
		}
	}, [items, itemsHeight, setItemsHeight]);

	return <div
		className={`category category-${open ? "open" : "closed"} ${finishedOpening ? "category-finished-opening" : ""}`}
		key={category}
		data-category={category}
	>
		<div className="category-header" onClick={e => {
			if (!open) {
				setCurrentCategory(category);
				trackEvent(EC_SHOP, E_CATEGORY_OPENED, category);
			} else {
				if (currentCategory === category) setCurrentCategory(null);
				trackEvent(EC_SHOP, E_CATEGORY_CLOSED, category);
			}
			setOpen(!open);
		}}>
			<h3 style={{
				color: headerColor
			}}>
				{category}
			</h3>
			<div className="controls v-middle">
				<button
					className="mini expander flexy"
					onClick={e => {
						e.stopPropagation();
						setOpen(!open);
					}}
				>
					<div className="count">
						{items.length}
					</div>
					<div className="icon" style={{
						transform: open ? "rotate(180deg)" : "rotate(0deg)"
					}}>
						<ImgIcon
							cursor={"pointer"}
							size={20}
							src={downArrow}
						/>
					</div>
				</button>
			</div>
		</div>
		{/* Then iterate the items. */}
		<div className="items" ref={itemsContainer} style={{
			height: open ? itemsHeight : 0
		}}>
			{children}
		</div>
	</div>
}